import { render } from "./AddNewItemGroup.vue?vue&type=template&id=33fd23b3"
import script from "./AddNewItemGroup.vue?vue&type=script&lang=js"
export * from "./AddNewItemGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__